const googleMapsApiKey =
  window.location.hostname === "localhost"
    ? "AIzaSyCmRUxe7E8dfmOX4ZIMpEqT1pptOU6mAiU"
    : "AIzaSyCmRUxe7E8dfmOX4ZIMpEqT1pptOU6mAiU";

const libraries = ["places"];

export { googleMapsApiKey, libraries };
